import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  interactive?: boolean;
  delay?: number;
}

/** Floating glassmorphism card — the core VaulTex surface. */
export function GlassCard({ children, className, interactive, delay = 0 }: GlassCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay, ease: [0.16, 1, 0.3, 1] }}
      whileHover={interactive ? { y: -4, scale: 1.005 } : undefined}
      className={cn(
        'glass rounded-2xl p-5',
        interactive && 'cursor-pointer transition-shadow hover:shadow-float',
        className,
      )}
    >
      {children}
    </motion.div>
  );
}
